// Utility functions for handling project status formatting

/**
 * Maps CMS projektstatus values to proper German display text
 */
export const formatProjectStatus = (status: string): string => {
  // Handle undefined/null/empty status
  if (!status) return 'Unbekannt';

  const statusMap: Record<string, string> = {
    'aktueller_verkauf': 'Aktueller Verkauf',
    'zukuenftige_projekte': 'Zukünftige Projekte',
    'vergangene_projekte': 'Vergangene Projekte'
  };

  return statusMap[status] || status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

/**
 * Gets the appropriate badge color for a project status
 */
export const getStatusBadgeColor = (status: string): string => {
  switch (status) {
    case 'aktueller_verkauf':
      return 'bg-cyan-100 text-cyan-800 border-cyan-200';
    case 'zukuenftige_projekte':
      return 'bg-cyan-100 text-cyan-800 border-cyan-200';
    case 'vergangene_projekte':
      return 'bg-gray-100 text-gray-800 border-gray-200';
    default:
      return 'bg-cyan-100 text-cyan-800 border-cyan-200';
  }
};
